export default __webpack_public_path__ + "static/media/SilverFoilRocket_06.fd6107a5.png";